import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'

function fetchLocations () {
  const database = firebase.firestore()
  return database.collection('locations').get()
    .then(res => {
      const locations = []
      res.forEach(location => {
        locations.push({
          id: location.id,
          data: location.data()
        })
      })
      return locations
    })
    .catch(err => console.log(err))
}
function createLocations (location) {
  const database = firebase.firestore()
  return database.collection('locations').add(location)
    .then(res => {
      return res
    })
}

export default {
  fetchLocations,
  createLocations
}
